import React from 'react';
import axios from 'axios';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import './index.css';
import App from './App';
import store from './redux/store';
import { loggedOut } from './redux/actions/authAction';

// The login session is an httpOnly cookie set by the API
axios.defaults.withCredentials = true;

// Any API call that finds the session expired sends the user back to the login page
axios.interceptors.response.use(undefined, (error) => {
  if (error?.response?.status === 401 && !error.config?.url?.includes('/auth/')) {
    store.dispatch(loggedOut());
  }
  return Promise.reject(error);
});

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <Provider store={store}>
    <App />
  </Provider>
);
